import {getCurrentLocale} from 'utils/common';
import {AgreementClause} from '@guestapp/sdk';
import i18n from 'i18next';

const NAME_PREFIX = 'agreement_clause_';

export function getAgreementClausesData(agreementClause: AgreementClause) {
  const language = getCurrentLocale().toUpperCase();
  const body = agreementClause.body_translations[language] || agreementClause.body;

  return {
    body,
    name: `${NAME_PREFIX}${agreementClause.id}`,
    required: agreementClause.is_required
      ? i18n.t('cheking_this_clause_is_required')
      : false,
  };
}
